import React from 'react';
import { graphql } from 'gatsby';

import TableSectionDS from 'design-system/src/components/organisms/TableSection';

export default function TableSection({ table }: any) {
    return (
        <TableSectionDS
            {...(table?.length && {
                table: {
                    cols: table[0]?.cols,
                    content: table[0]?.matrixContent,
                },
            })}
        />
    );
}

export const fragment = graphql`
    fragment DatoCmsTableSection on DatoCmsTableSection {
        table {
            ...DatoCmsTableBlock
        }
    }
`;
